
        import '/home/builduser/work/97f164ade279074e/santa-editor/packages/panels/promotionalPanels/advancedMenusMigrationPanel/advancedMenusMigrationPanel.scss.css.virtualfile';
        module.exports = {"illustration":"_illustration_1u6lg_7","listContainer":"_listContainer_1u6lg_11","check":"_check_1u6lg_14"};